import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ClientDatabaseFilterInput } from '@/graphql/contracts/_generated_/contracts';
import {
  GetPaginatedFilteredClientDatabases,
  GetPaginatedFilteredClientDatabasesVariables,
} from '@/graphql/contracts/_generated_/getPaginatedFilteredClientDatabases.query';
import GetPaginatedClientDatabasesQuery from '@/graphql/contracts/getPaginatedFilteredClientDatabases.query.gql';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';
import { notificationService } from '@/services/notification/notification.client';

export type PaginatedFilteredClientDatabases = PaginatedFilteredGridData<ClientDatabaseFilterInput>;

export default function useGetClientDatabases() {
  const [_getClientDatabases] = useLazyQuery<
  GetPaginatedFilteredClientDatabases,
  GetPaginatedFilteredClientDatabasesVariables
  >(GetPaginatedClientDatabasesQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) => {
      notificationService.open({ title: 'Error', text: err.message, type: 'danger', });
    },
  });

  const getClientDatabases = async (params: PaginatedFilteredClientDatabases) => {
    const response = await _getClientDatabases({
      variables: {
        ...params,
      } as GetPaginatedFilteredClientDatabasesVariables,
    });
    return response.data?.paginatedFilteredClientDatabases;
  };

  return {
    getClientDatabases,
  };
}
